var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.props.tag,{tag:"component",class:[ _vm.data.staticClass ].concat( _vm.data.class ),style:([ _vm.data.staticStyle ].concat( _vm.data.style ))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }